
// src/components/library/ReleaseModal.jsx
import React from 'react';
import { useLibrary } from '../../context/LibraryContext';
import TrackList from './TrackList';

const ReleaseModal = ({ onClose }) => {
  const { selectedRelease, getContributorsByReleaseId } = useLibrary();
  
  if (!selectedRelease) return null;
  
  const contributors = getContributorsByReleaseId(selectedRelease.id);
  
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div 
        className="fixed inset-0 bg-black bg-opacity-75 transition-opacity"
        onClick={onClose}
      ></div>
      
      <div className="bg-gray-800 rounded-lg shadow-xl overflow-hidden z-10 max-w-4xl w-full mx-4 max-h-[90vh] flex flex-col">
        <div className="flex justify-end p-2">
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white focus:outline-none"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        <div className="overflow-y-auto p-6 flex-grow">
          <div className="flex flex-col md:flex-row gap-6">
            <div className="md:w-1/3">
              <img
                src={selectedRelease.coverImage}
                alt={selectedRelease.title}
                className="w-full h-auto rounded-lg shadow-lg"
              />
              <div className="mt-6">
                {(contributors.length !== 0) ? 
                              <div className="mt-6">
                                <h3 className="text-lg font-semibold text-gray-200 mb-3">Contributors</h3>
                                <ul className="space-y-2">
                                    {contributors.map((contributor) => (
                                        <li key={contributor.id} className="text-gray-300">
                                        <span className="font-medium">{contributor.name}</span> - {contributor.contribution}
                                        </li>
                                    ))}
                                </ul>
                                </div>
                                :
                                <div></div>
                }

              </div>
            </div>
            
            <div className="md:w-2/3">
              <h2 className="text-2xl font-bold text-gray-100 mb-2">{selectedRelease.title}</h2>
              <p className="text-gray-400 mb-4">
                Released: {new Date(selectedRelease.releaseDate).toLocaleDateString()}
              </p>
              <p className="text-gray-300 mb-6">{selectedRelease.description}</p>
              
              <h3 className="text-xl font-semibold text-gray-200 mb-4">Tracks</h3>
              <TrackList releaseId={selectedRelease.id} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReleaseModal;